import styled, { css } from 'styled-components';
import SVG from 'react-inlinesvg';
import { getIconSize } from '../styled/buttons-factory';
import RichText from '../rich-text/base';

export const CalloutWrapper = styled.div`
  ${({ $type, theme }) => css`
    border: 1px solid;
    border-left: 4px solid;
    padding: ${theme.spacing.standard};
    display: flex;
    gap: ${theme.spacing.small};
    margin-bottom: ${theme.spacing.large};

    ${$type === 'warning'
      ? `
    
        background-color: ${theme.palette.alertLight};
        border-color: ${theme.palette.alertDark};

    `
      : null};
  `}
`;

export const CalloutHeading = styled.h3`
  ${({ theme }) => css`
    margin-top: 0;
    font-size: ${theme.fontsize.h3};
  `}
`;

export const IconHolder = styled(SVG)`
  width: ${({ theme, $size }) => getIconSize({ theme, $size })};
  height: ${({ theme, $size }) => getIconSize({ theme, $size })};
  margin-top: 8px;
  flex-shrink: 0;
`;

export const Message = styled(RichText)`
  &:last-of-type {
    margin-bottom: 0;
  }
`;
